import React from "react";
import Page from "../../../layout/web/Page"
import Connector from "../../../redux/connector";
import {fetchDataEntity} from "../../../api/entity-data";
import GridItem from "../../../components/Common/dashboard/Grid/GridItem";
import TableDataView from "../../../components/Common/tables/TableDataView";
import {UpCaseFirst, GetRowOptions, IsNotSuperUser,FindFieldFromRecordWithData} from "../../../api/fn";
import LoadingProcessing from "../../../components/Common/page/Common/LoadingProcessing";
import Title from "../../../components/Common/Title";
import {GetUserToken} from "../../../api/token";
import {PostToPbx} from "../../../api/http-post";
import {Button, Form, Input, Select, Alert} from "antd";
import {LockOutlined} from "@ant-design/icons";

const {Option} = Select;

class PbxSettingTrunkPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            isLoading: false,
            component: "list"
        }
    }

    componentDidMount = async () => {
        IsNotSuperUser()
        await this.loadInitialData()
    }
    loadInitialData = async () => {
        await fetchDataEntity("Data", "manager/entity", "trunks", this,false);
        await fetchDataEntity("Companies", "client/entity", "company", this)
    }
    onAddRecord = () => {
        this.setState({
            component: "form"
        })
    }
    onDelete = () => {
        this.setState({
            component: "list"
        })
    }
    onFinish = async (values) => {
        if (!window.confirm("Are you sure you want to submit this range ?")) {
            return
        }
        let _this = this;
        let user = GetUserToken();
        let hub = {...values};
        hub.Codecs ={
            gsm:"gsm",
            alaw:"alaw",
            ulaw:"ulaw"
        }
        let endpoint = "/manager/entity/insert/trunks";
        await PostToPbx(hub, endpoint, async (data) => {
            console.log("):(--->onFinish Trunk response: ", data)
            _this.setState({
                isLoading: false,
                component: "list"
            })
            if (data === null) {
                alert("Server connection Error! try again later");
                return
            }
            alert("Thank you , range submitted!")
            _this.setState({
                isLoading: false,
                component: "list"
            });
            await _this.loadInitialData();
        });
    };

    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    handleChange = (e) => {

    }


    getColumns = () => {
        return [
            {id: "Org", label: "Client"},
            {id: "Name", label: "Name"},
            {id: "Host", label: "Host"},
            {id: "Port", label: "Port"},
            {id: "Username", label: "Username"},
            {id: "Password", label: "Password"},
        ];

    }

    renderList = () => {
        if (this.state.component !== "list") {
            return
        }
        let ls = []; //this.state.Data;
        for(let i in this.state.Data){
            let row = this.state.Data[i];
            row.Org = FindFieldFromRecordWithData("CustomerNumber",row.Org ,"Name",this.state.Companies);
            ls.push(row)
        }

        let data = {columns: this.getColumns(), data: ls};
        return (
            <GridItem xs={12} sm={12} md={12}>
                <br/>
                <TableDataView
                    {...data}
                    tableTitle={UpCaseFirst("Range Extension")}
                    onAddRecord={this.onAddRecord}
                    onDelete={this.onDelete}
                />
            </GridItem>
        )
    }
    renderForm = () => {
        if (this.state.component !== "form") {
            return
        }

        let companies = GetRowOptions("CustomerNumber", "Name", this.state.Companies);

        let inputList = [
            {
                name: "Org",
                label: "Name of Company",
                type: "option",
                required: true,
                options: companies,
                message: "Please input your company name"
            },
            {name: "Name", label: "Range Name", type: "text", required: true, message: "Please input your range name"},
            {name: "Host", label: "Host server", type: "text", required: true, message: "Please input your host"},
            {name: "Port", label: "Port", type: "text", required: true, message: "Please input your Port"},
            {name: "Username", label: "Username", type: "text", required: true, message: "Please input your Username"},
            {name: "Password", label: "Password", type: "text", required: true, message: "Please input your Password"},
        ]


        const layout = {
            labelCol: {span: 8},
            wrapperCol: {span: 16},
        };
        const tailLayout = {
            wrapperCol: {offset: 8, span: 16},
        };


        return (
            <Form
                {...layout}
                onSubmit={this.handleSubmit}
                className="login-form"
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                name="basic"
                initialValues={{remember: true}}
                style={{minWidth: "50%"}}
            >
                <Alert style={{margin: '16px 0'}} message="New Trunk"/>

                {inputList.map((row) => {
                    if (row.type === "option") {
                        return (
                            <Form.Item
                                {...tailLayout}
                                label={row.label}
                                name={row.name}
                                rules={[{required: row.required, message: row.message}]}
                            >
                                <Select
                                    name={row.name}
                                    defaultValue=""
                                    /*style={{ width: 120 }}*/
                                    onChange={this.handleChange}
                                >
                                    {row.options.map((record, index) => {
                                        return (
                                            <Option value={record.key}>{record.val}</Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                        )
                    }
                    return (
                        <Form.Item
                            {...tailLayout}
                            label={row.label}
                            name={row.name}
                            rules={[{required: row.required, message: row.message}]}
                        >
                            <Input
                                onChange={this.handInput}
                                type={row.type}
                                /*prefix={<LockOutlined type={row.prefix} style={{fontSize: 13}}/>}*/
                            />
                        </Form.Item>
                    )
                })}

                <Form.Item {...tailLayout}>
                    <Button
                        {...tailLayout}
                        type="secondary"
                        htmlType="submit"
                        style={{marginRight: 20}}
                        onClick={() => this.setState({component: "list"})}
                    >
                        Cancel
                    </Button>

                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        )
    }

    render() {
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    overflow: "auto"
                }}>
                    <Title style={styles.title}>Trunk Management</Title>
                    {this.renderList()}
                    {this.renderForm()}

                </div>
                <LoadingProcessing open={this.state.isLoading}/>
            </Page>
        )
    }
}

export default Connector(PbxSettingTrunkPage);

const styles = {
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

